import { graphql } from '~/graphql';
import { useGraphqlQuery } from '~/hooks/useGraphqlQuery';

const GetFeatureFlagsDocument = graphql(`
  query getFeatureFlags {
    featureFlags {
      name
      enabled
    }
  }
`);

export const useGetFeatureFlags = () =>
  useGraphqlQuery(GetFeatureFlagsDocument, ['featureFlags']);
